import { createContext, useContext } from 'react'

import { RegisteredUser } from '../users_management/Users/usersContainer'

export interface UserContextData extends RegisteredUser {
	refresh: () => Promise<void>
	meta?: 'not logged in'
	jwt: string
	actAs: boolean
}

export const initialData: UserContextData = {
	id: '',
	username: '',
	role: 0,
	group_id: 0,
	firstname: '',
	lastname: '',
	contactPhone: '',
	lastLogin: '',
	created: '',
	modified: '',
	user_status_id: '',
	associatedClients: [],
	passwordFlag: false,
	Group: {
		id: '',
		name: '',
		type: 0,
		logo_url: '',
		domain: '',
		primary_color: '',
		contrast_color: '',
		contact_name: '',
		business_id: '',
		phone_number: '',
		currency: '',
		payment_option: 'creditcard',
		billing_option: '',
		billing_email: '',
		invoicing_address: '',
		operator: '',
		reference: '',
		info: '',
		logo_option: '',
		bm_default_nativeflow: 50,
		bm_default_readpeak: 50,
		customer_id: 0,
		invoicing_allowed: false,
		preapproval_required: true,
		white_label_id: 0,
		typename: '',
		language: 'fi',
		country: 'FI',
		markup_fee_visible: false,
		markup_fee_default: 0,
	},
	blocked: false,
	language: '',
	tos_acceptance: null,
	// eslint-disable-next-line @typescript-eslint/no-empty-function
	refresh: async () => {},
	jwt: '',
	actAs: false,
	approved: false,
	confirmed: false,
	disable_password: false,
}

export const UserContext = createContext<UserContextData>(initialData)
export const useUserContext = () => useContext(UserContext)
